import React, {
  useRef,
  useMemo
} from 'react';


import BulkRequestDocumentForm from '../../../../bulk/request/document/form';
import DocumentFormContext from '../../../../document/context/document_form_context';
import { fetchCustomFieldValue } from "../../../../helper/custom_field/helper";

import {
  index as indexEntities
} from "../../../entity/axios";

import {
  create as createBulkRequest
} from './axios';

const AbstractBulkRequestDocumentForm = props => {

  const {
    bulkRequest,
    currentEntityType,
    currentUser,
    currentCustomer,
    data: {
      customFields
    }
  } = props;

  const actionsProps = {
    indexEntities: indexEntities,
    createBulkRequest: createBulkRequest,
    indexEntitiesPath: Routes.abstract_entities_path,
    showBulkRequestPath: Routes.abstract_bulk_request_document_path,
    indexBulkRequestPath: Routes.abstract_bulk_request_documents_path
  }

  const defaultRequestParams = { current_entity_type_id: currentEntityType.hashid };
  const context = "abstract_bulk";

  const entityConfiguration = {
    key: 'entities',
    form: {
      entityItemsAttributes: {
        key: 'entity_items_attributes',
        entityId: 'entity_id'
      },
    },
    label: {
      singular: I18n.t("abstract.bulk.request.documents.form.tabs.entities", { entity: currentEntityType.plural_name }),
      plural: I18n.t("abstract.bulk.request.documents.form.tabs.entities", { entity: currentEntityType.plural_name })
    },
    navButtonTitle: I18n.t("abstract.bulk.request.documents.form.tabs.entities_title",
      { entity: currentEntityType.plural_name }
    )
  }

  const customFieldEmailNotifications = useMemo(() => {
    const entityTypes = [
      ...currentEntityType.related_entity_types,
      currentEntityType
    ]

    let emailCustomFields = {}

    _.each(entityTypes, entityType => {
      const customFieldEmailNotifications = _.filter(
        entityType.custom_fields, { is_notification_email: true }
      )

      if (customFieldEmailNotifications.length > 0) {
        emailCustomFields[entityType.plural_name] = customFieldEmailNotifications
      }
    })

    return emailCustomFields;
  }, [])

  const documentFormContextValue = {
    currentUser: currentUser || {},
    currentCustomer: currentCustomer || {},
    currentEntityType: currentEntityType || {},
    isPersisted: false,
    context: "abstract_bulk",
    data: { ...props?.data, customFieldEmailNotifications: customFieldEmailNotifications },
    entities: [],
  }

  const entityHeaderConfigTab = useMemo(() => {
    return _.flattenDeep([
      {
        label: I18n.t('activerecord.attributes.abstract/entity.identifier'),
        key: 'identifier'
      }, _.map(customFields, customField => {
        return {
          label: customField.label,
          key: `custom_fields.${customField.code}`
        }
      })
    ])
  }, [])

  // ---------------- START TABLE ----------------

  const tableColumnsDefault = [
    {
      field: 'identifier',
      header: I18n.t("activerecord.attributes.abstract/entity.identifier"),
      body: row => row?.identifier || I18n.t("no_entry"),
      filter: {
        enabled: true,
        filterrific: {
          search: 'search_query'
        }
      }
    }
  ]

  const tableColumnsRelatedEntities = useMemo(() => {
    return _.map(currentEntityType.related_entity_types, function (relatedEntityType, index) {
      return {
        field: `related_entities[${index}].identifier`,
        header: `${I18n.t("activerecord.attributes.abstract/entity.identifier")} ${relatedEntityType.singular_name}`,
        body: row => row?.related_entities?.[index]?.identifier || I18n.t("no_entry")
      }
    })
  }, [currentEntityType.related_entity_types])

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${customField.code}`,
        header: _.capitalize(customField.label),
        body: row => fetchCustomFieldValue(customField, row?.custom_fields?.[customField.code], currentUser),
        filter: {
          enabled: true,
          filterrific: {
            search: `search_by_key_abstract_custom_fields`
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [customFields])

  const tableColumns = _.concat(
    tableColumnsDefault,
    tableColumnsRelatedEntities,
    tableColumnsCustomFields
  )
  // ---------------- END TABLE ----------------

  return (
    <DocumentFormContext.Provider value={documentFormContextValue}>
      <div className="row">
        <div className="col-12">
          <BulkRequestDocumentForm
            bulkRequest={bulkRequest}
            dataTableConfiguration={{
              columns: tableColumns
            }}
            configuration={{
              showDistributionListFilter: false,
              defaultRequestParams: defaultRequestParams,
              entity: entityConfiguration,
              entityHeaderConfigTab: entityHeaderConfigTab,
              context: context,
              formName: 'abstract_bulk_request_document'
            }}
            actions={
              actionsProps
            }
            data={{
              ...props?.data,
              ...{ customFieldEmailNotifications: customFieldEmailNotifications },
              currentUser: currentUser
            }}
          />
        </div>
      </div>
    </DocumentFormContext.Provider>
  )
};

export default AbstractBulkRequestDocumentForm;
